import { jsx, jsxs } from "react/jsx-runtime";
import { H1, H2, H3, H4, H5, H6, YStack } from "tamagui";
function HeadingsDemo() {
  return /* @__PURE__ */ jsxs(YStack, { alignSelf: "center", children: [
    /* @__PURE__ */ jsx(H1, { children: "Heading 1" }),
    /* @__PURE__ */ jsx(H2, { children: "Heading 2" }),
    /* @__PURE__ */ jsx(H3, { children: "Heading 3" }),
    /* @__PURE__ */ jsx(H4, { children: "Heading 4" }),
    /* @__PURE__ */ jsx(H5, { children: "Heading 5" }),
    /* @__PURE__ */ jsx(H6, { children: "Heading 6" })
  ] });
}
export {
  HeadingsDemo
};
//# sourceMappingURL=HeadingsDemo.js.map
